import { Component, Input, Output, HostListener, EventEmitter, OnInit } from "@angular/core";

@Component( {
  selector: 'app-search-view-btns',
  template: require('./app-search-view-btns.component.pug'),
  styles: [require('./app-search-view-btns.component.scss')]
} )

export class AppSearchViewBtnsComponent {
  private ids: string[] = [ `total`,'launch', 'reset'];

  constructor() {}

  ngOnInit() {}

  @Input() total: number;
  @Output() reset: any = new EventEmitter();
  @Output() launch: any = new EventEmitter();

  @HostListener( 'click', ['$event']) onClickHandler( event: any ) {
    const { id } = event.srcElement;
    switch( id ) {
      case 'launch':
        this.launch.emit();
        break;
      case 'reset':
        this.reset.emit({ isSearch: false });
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/components/app-search-view-btns/app-search-view-btns.component.ts